import React from 'react'
import FormSF from '../../../widgets/form/FormSF'
import EditorSF from '../../../widgets/input/EditorSF'
import SelectMultiSF from '../../../widgets/input/SelectMultiSF'

const MessageCreateUI = ({context, messageList,
    html, onHtmlChange, onSubmit, submitted, onCancel,
    userIdList, projectUserList, onUsersChange
  }) =>
  <FormSF context={context} messageList={messageList} buttonMessageKey='c_add'
    cancelMessageKey={html ? 'c_cancel' : null}
    onSubmit={onSubmit} onCancel={onCancel} busy={submitted}
  >
    <EditorSF
      messageList={messageList}
      html={html}
      onChange={onHtmlChange}
      placeholderKey='c_add_comment'
    />
    <div className='g_m_top_50' />
    <SelectMultiSF
      messageList={messageList}
      optionList={projectUserList
        .filter(projectUser => projectUser.roleId !== null)
        .map(projectUser => ({value: projectUser.userId, label: projectUser.name}))
      }
      onChange={onUsersChange}
      selectedKeys={userIdList}
    />

    {/*
      menuIsOpen={editMode}
      placeholderKey='c_select'
    */}
  </FormSF>

export default MessageCreateUI
